import { render, staticRenderFns } from "./confList.vue?vue&type=template&id=4164c06b&scoped=true&"
import script from "./confList.vue?vue&type=script&lang=js&"
export * from "./confList.vue?vue&type=script&lang=js&"
import style0 from "./confList.vue?vue&type=style&index=0&id=4164c06b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4164c06b",
  null
  
)

export default component.exports